import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { type VariantProps, cva } from 'class-variance-authority';
import { cn } from 'cn';
const labelVariants = cva(['text-secondary-600 text-xs font-medium leading-4',
// refreshed shell: same label as the web-form fields.
'refresh:text-muted-foreground refresh:text-sm refresh:leading-5 refresh:tracking-[-0.14px]', 'peer-disabled:cursor-not-allowed peer-disabled:opacity-70']);
const Label = React.forwardRef<React.ElementRef<typeof LabelPrimitive.Root>, React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>>(({
  className,
  ...props
}, ref) => <LabelPrimitive.Root ref={ref} className={cn(labelVariants(), className)} {...props} />);
Label.displayName = LabelPrimitive.Root.displayName;
export { Label };